/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import '../../css/event210621.css';

import { toast } from 'react-toastify'; //토스트(toast)
// import moment from "moment";
import axios from 'axios';

class ContentItem2 extends Component {
  state = {
    alram: this.props.childProps.alramFlag,
  };
  _goContent = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };

  _toggleAlram = async () => {
    // const { alram } = this.props;

    this.setState({
      alram: 100,
    });
  };
  _toggleAlramApi = () => {
    const { apiUrl, loginId } = this.props;
    const { contentSerial } = this.props.childProps;

    return axios
      .post(apiUrl + '/alramToggle', {
        params: {
          userid: loginId,
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.error('오류가 발생했습니다.');
        //alert('오류가 발생했습니다.')
      });
  };
  _onExpect = () => {
    const { contentSerial, _expect, grade } = this.props.childProps;
    _expect(contentSerial, grade);

    this.setState({
      alram: 100,
    });
  };
  _onExpectApi = () => {};
  render() {
    const { contentSerial, img, comment, title } = this.props.childProps;
    const { imgUrl } = this.props;
    const { alram } = this.state;
    return (
      <Fragment>
        <li>
          <div className="thumb">
            <a
              nClick={() => this._goContent(contentSerial)}
              style={{ cursor: 'pointer' }}
            >
              <img src={img} />
            </a>
          </div>
          <div className="info">
            <p className="date">
              <img
                src={imgUrl + '/img/event/event210926/ico_live.png'}
                alt="LIVE"
              />{' '}
              {comment}
            </p>
            <p className="subject">
              <a
                onClick={() => this._goContent(contentSerial)}
                style={{ cursor: 'pointer' }}
              >
                {title}
              </a>
            </p>
          </div>
          <button
            type="button"
            className={alram === 0 ? 'btnAlram' : 'btnAlram active'}
            onClick={this._onExpect}
          >
            백신접종
          </button>
          {/*<button onClick={this._toggleAlram} type="button" className={alram === 0 ? "btnAlram" : "btnAlram active"}>{alram === 0 ? '본방알림 받음' : '본방알림 취소'}</button>*/}
        </li>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ContentItem2));
